<template>
    <v-list-item :to="`/${userDetail.username}`" @click="$emit('clicked')">
        <v-list-item-avatar color="blue">
            <img v-if="userDetail.avatar_url" :src="userDetail.avatar_url" :alt="userDetail.name">
            <span class="white--text" v-else>{{userDetail.name[0]}}</span>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title>{{userDetail.username}}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
            <btn-follow @followAction="followUser" @unFollowAction="unFollowUser" :loading="followUpdating" :following="userDetail.following" v-if="user.id !== userDetail.id"></btn-follow>
        </v-list-item-action>
    </v-list-item>
</template>
<script>

import userMixin from "@/mixins/mixin-users"
import btnFollow from "@/components/buttons/follow-button.vue"

export default {
    mixins: [userMixin],

    components: {
        btnFollow
    },

    data: () => ({}),

    props: {
        userDetail: Object
    },

    methods: {

        followUser() {
            this.follow(this.userDetail.id)
        },

        unFollowUser() {
            this.unFollow(this.userDetail.id)
        }
    }
}
</script>